<template>
  <div class="about-us" :class="{english:lang=='EN'}">
    <Header ref="header" id="header"></Header>
    <img class="img-fluid"
         :style="isMobile?{marginTop:'3.5rem'}:''"
         :class="isMobile?'visible-xs':'hidden-xs'"
         src="../assets/img/aboutus/zlgj3dd.jpg"
         ref="banner"
    >
    <!-- <div class="banner" ref="banner">
      <div class="swiper-container" :class="isMobile?'swiper-container-vs':'swiper-container-hs'">
          <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="item in swiperImg">
                    <img class="img-fluid"
                          :style="isMobile?{marginTop:'3.5rem'}:''"
                          :class="isMobile?'visible-xs':'hidden-xs'"
                          :src="item"
                          ref="banner"
                      >
                  </div>
          </div>
          <div class="swiper-pagination"></div>
      </div>
    </div> -->
    <div style="width: 100%;" ref="operateOL" :class="{operateFixed:isOperateFixed}">
      <div class="hidden-xs">
        <div class="operate-ol">
          <div class="operate">
            <div class="caption">{{$t('aboutUs.us')}}</div>
            <div class="tab-ul">
              <span v-for="item in tabs" @click="goAnchor(item)" :class="{active:curMenu == item.label}">{{$t(item.name)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="visible-xs">
        <div class="operate-ol">
          <div class="operate">
            <div class="caption">{{$t('aboutUs.us')}}</div>
            <div class="dropdown">
              <div class="dropdown-toggle"  type="button" id="dropdownMenu4" data-toggle="dropdown"
                   aria-haspopup="true" aria-expanded="true" style="color:#3292FF;height:3.5rem;line-height:3.5rem">
                {{$t(curMenuName)}}<i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <ul class="dropdown-menu dropdown-ul dropdown-menu-right" aria-labelledby="dropdownMenu4">
                <li v-for="(item,index) in tabs" @click="goAnchor(item)" :class="{'active':index==curTabIndex}">{{$t(item.name)}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AboutCompany id="aboutCompany" style="position:relative;z-index:1"></AboutCompany>
    <company-condition id="companyCondtion" style="position:relative;z-index:1"></company-condition>
    <company-activity id="companyActivity" style="position:relative;z-index:1"></company-activity>
    <!-- <CompanyNews id="companyNews"></CompanyNews> -->
<!--    <Address id="companyAdderss" style="position:relative;z-index:1" ref="companyAdderss"></Address>-->
<!--    <LinkUs id="linkUs" style="position:relative;z-index:1"></LinkUs>-->
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from '@/components/common/Header'
  import Footer from '@/components/common/Footer'
  import AboutCompany from '@/components/common/aboutus/AboutCompany'
  import CoreTeam from '@/components/common/aboutus/CoreTeam'
  import Address from '@/components/common/aboutus/Address'
  // import LinkUs from '@/components/common/aboutus/LinkUs'
  import Lantern from '@/components/common/Lantern'
  import {mapGetters} from 'vuex'
  import Swiper from '../../node_modules/swiper/js/swiper.min.js'
  import CompanyCondition from '@/components/common/joinus/CompanyCondition'
  import CompanyActivity from '@/components/common/joinus/CompanyActivity'
  // import CompanyNews from '@/components/common/joinus/CompanyNews'
  export default {
    name: 'AboutUs',
    components: {
      Header,
      Footer,
      AboutCompany,
      CoreTeam,
      Lantern,
      Address,
      // LinkUs,
      CompanyCondition,
      CompanyActivity,
      // CompanyNews
    },
    props: {},
    data() {
      return {
        mySwiperHs:null,
        mySwiperVS:null,
        isOperateFixed: false,
        curMenu: 'aboutCompany',
        curMenuName: 'aboutUs.company',
        CompanyNews: {
          title: 'aboutUs.news',
          introduction: 'aboutUs.tip2',
          model: 'card',
          bkColor: 'blue',
          events: [
            {
              img: require('../assets/img/aboutus/info4.png'),
              time: '2019.09',
              event: 'aboutUs.message1.message13'
            },
            {
              img: require('../assets/img/aboutus/info3.png'),
              time: '2018.09',
              event: 'aboutUs.message1.message10'
            },
            {
              img: require('../assets/img/aboutus/info2.png'),
              time: '2018.08',
              event: 'aboutUs.message1.message11'
            },
            {
              img: require('../assets/img/aboutus/info1.png'),
              time: '2018.07',
              event: 'aboutUs.message1.message12'
            }
          ]
        },
        curTabIndex:0,
        tabs: [
          {
            index:0,
            label: 'aboutCompany',
            name: 'aboutUs.company'
          },
          {
            index:1,
            label: 'companyCondtion',
            name: 'aboutUs.companyCondtion'
          },
          {
            index:2,
            label: 'companyActivity',
            name: 'aboutUs.companyActivity'
          },
          // {
          //   label: 'companyNews',
          //   name: 'joinUs.companyNewsTitle'
          // },
          // {
          //   index:3,
          //   label: 'companyAdderss',
          //   name: 'aboutUs.address'
          // },
          // {
          //   index:4,
          //   label: 'linkUs',
          //   name: 'aboutUs.contact'
          // },
        ]
      }
    },
    methods: {
      scrollEvent() {
        let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 0) {
          this.$refs.header.setHeaderFixed(true)
          if (screenWidth >= 768) {
            if (scrollTop > this.$refs.banner.offsetHeight - this.$refs.operateOL.offsetHeight) {
              this.isOperateFixed = true
              $('#header').slideUp('fast')
            } else {
              this.isOperateFixed = false
              $('#header').slideDown('fast')
            }
          } else {
            if (scrollTop > this.$refs.banner.offsetHeight) {
              this.isOperateFixed = true
              $('#header').slideUp('fast')
            } else {
              this.isOperateFixed = false
              $('#header').slideDown('fast')
            }
          }
        } else {
          this.isOperateFixed = false
          $('#header').slideDown('fast')
          this.$refs.header.setHeaderFixed(false)
        }
        // 设置双向锚点
        this.setCurTab()
      },
      goAnchor(item) {
        let selector = item.label
        this.curMenu = selector
        this.curMenuName = item.name;
        this.curTabIndex=item.index;
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        let scrollHeight = 0
        if (scrollTop <= this.$refs.operateOL.offsetTop) {
          scrollHeight = $('#' + selector).offset().top - this.$refs.operateOL.offsetHeight * 2 + 10
        } else {
          scrollHeight = $('#' + selector).offset().top - this.$refs.operateOL.offsetHeight + 10
        }
        $('html,body').animate({
          scrollTop: scrollHeight
        }, 300)
        return
      },
      setCurTab() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // 设置锚点双向绑定
        let idArr = ['aboutCompany','companyCondtion','companyActivity', 'companyAdderss']
        for (let i = 0; i < idArr.length; i++) {
          if (scrollTop >= $('#' + idArr[i]).offset().top - this.$refs.operateOL.offsetHeight) {
            this.curMenu = idArr[i]
            this.curMenuName = this.getMenuNameById(idArr[i])
          }
        }
        return
      },
      getMenuNameById(menuId) {
        let name = ''
        for (let i = 0; i < this.tabs.length; i++) {
          if (menuId == this.tabs[i].label) {
            name = this.tabs[i].name
          }
        }
        return name
      }
    },
    mounted() {
      // 图片展示 对齐
      console.log(this.lang);
      console.log(this.$store.state.lang);
      let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
       if(screenWidth>768){
          var width=(screenWidth-$('#companyAdderss .content').width())/2+$('#companyAdderss .content').width();
           if(screenWidth>=1400){
             $('.lantern .content').css({'max-width':width/16+'rem'});
           }else if(screenWidth<1400&&screenWidth>=1200){
              $('.lantern .content').css({'max-width':width/14+'rem'});
           }else if(screenWidth>1200&&screenWidth>=768){
              $('.lantern .content').css({'max-width':width/12+'rem'});
           }
        }
      $('html,body').scrollTop(0)
      this.setCurTab()
      window.addEventListener('scroll', this.scrollEvent);
      // let mySwiperHs = new Swiper('.swiper-container-hs', {
      //   speed: 1000,
      //   autoplay: true,
      //   pagination: {
      //     el: '.swiper-pagination',
      //      clickable: true,
      //   },
      // });
      // let mySwiperVS = new Swiper('.swiper-container-vs', {
      //   speed: 1000,
      //   autoplay: true,
      //   pagination: {
      //     el: '.swiper-pagination',
      //      clickable: true,
      //   },
      // });
      // window.eventBus.$emit('')
      console.log()
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scrollEvent)
    },
    computed: {
      ...mapGetters(['isMobile', 'lang','allCount']),
      getComponentName() {
        return 'AboutUs'
      }
    }

  }
</script>

<style lang="scss" scoped>
  .operateFixed {
    position: fixed;
    top: 0;
    z-index: 1001;
    box-shadow: 0rem 0rem 0.75rem 0rem rgba(179, 193, 218, 0.41);
  }

  .about-us {
    background: #f3f6fb;

    .operate-ol {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      background: #FFFFFF;
      border-bottom: 1px solid rgba(243, 246, 251, 1);

      .operate {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height:5rem;
        width: 100%;
        max-width: 75rem;

        .caption {
          font-size: 1.13rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 500;
          color:#333;
          line-height:5rem;
        }

        .tab-ul {
          span {
            font-size:1rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 500;
            color: #666;
            line-height: 4.37rem;
            cursor: pointer;
            margin: 0 0.8rem;
          }

          span:hover {
            color: #3292FF;
          }

          .active {
            color: #3292FF;
          }
        }
      }
    }

    .visible-xs {
      .operate-ol {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        background: #FFFFFF;
        border-bottom: 1px solid rgba(243, 246, 251, 1);
        position: relative;

        .operate {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 3.5rem;
          width: 100%;
          max-width: 90%;
          border-bottom: 1px solid rgba(243, 246, 251, 1);
          position: relative;

          .caption {
            font-size: 1rem;
            // font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color:#333;
            line-height: 4.37rem
          }

          .el-dropdown-link:focus {
            outline: 0;
          }

          .el-dropdown-menu__item {
            text-align: center;
          }

          .dropdown-ul {
            margin-top: 0.5rem;
            // width: 2rem;
            min-width: 100px;
            li {
              text-align: center;
              margin: 0.8rem 0;
              &.active{
                color: #3292FF;
              }
            }
          }
        }
      }
    }
  }

  .english {
    .visible-xs {
      .dropdown-ul {
        margin-left: -2.5rem !important;
        min-width:180px !important;
        li {
          padding: 0 1rem;
          text-align: left !important;
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
    /deep/ .swiper-container-hs.swiper-container-horizontal>.swiper-pagination-bullets,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
        bottom: 10%;
        left: 50%;
        max-width: 67.5rem;
        transform: translate(-50%, 0%);
        text-align: left;
    }

    /deep/ .swiper-container-hs.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
        background: url("../assets/img/mainpage/hexagon_btn.png") no-repeat;
        width: 1.125rem;
        height: 1.5rem;
        background-size: 100%;
        cursor: pointer;
        margin-right: 2.25rem;
    }

    /deep/ .swiper-container-hs.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet.swiper-pagination-bullet-active {
        background: url("../assets/img/mainpage/hexagon_btn_active.png") no-repeat;
        width: 1.125rem;
        height: 1.5rem;
        background-size: 100%;
    }
    /deep/ .swiper-container-vs  .swiper-pagination{
      width: 100%;
      bottom: 0;
    }
     /deep/ .swiper-container-vs  .swiper-pagination-clickable .swiper-pagination-bullet{
      margin: 0 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue